<template>

</template>

<script>
  export default {
     name: 'Property_Borrow',
     data () {
       return {
          
        };
     },
     methods: {
    
     }
   }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Property/Property_Borrow.vue